import { getIsMobile } from '../../../utils/getIsMobile';
import { HEADER_BUTTON_WIDTH } from '../constants';

export const useHeaderSizes = () => {
    const { isMobile } = getIsMobile();
    const headerHeight = isMobile ? 56 : 76;

    return {
        headerHeight,
        headerButtonTop: (headerHeight - HEADER_BUTTON_WIDTH) / 2 / 8,
    };
};
